import type {
    FC
} from "react";
import {
    Animated,
    View
} from "react-native";
import type IProgressStepProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useAnimatedState
} from "../../../../helpers/motion";
import type {
    ProgressPartContentProps
} from "../../type";
import {
    withProgressContext
} from "../../context";

const ProgressStepContent: FC<ProgressPartContentProps<IProgressStepProps>> = ({
    customTheme: customThemeProp,
    isDone = false,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        shapeConfigs,
        radiuses
    } = NCoreUIKitTheme.useContext(customTheme);

    const fillOpacity = useAnimatedState({
        intent: "valueChange",
        value: isDone ? 1 : 0,
        customTheme
    });

    const {
        container: containerDynamicStyle,
        fill: fillDynamicStyle
    } = useStyles({
        backgroundColor: context.currentColors.trackColor,
        fillColor: context.currentColors.indicatorColor,
        shapeConfigs,
        radiuses
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        <Animated.View
            style={[
                stylesheet.fill,
                fillDynamicStyle,
                {
                    opacity: fillOpacity
                }
            ]}
        />
    </View>;
};
export default withProgressContext("Step", ProgressStepContent);
